import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full p-4 space-x-2 bg-primary-50 rounded-2xl mb-7"
}
const _hoisted_2 = { class: "flex flex-wrap justify-between w-full space-y-2 lg:flex-nowrap lg:space-y-0" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-darkgray-800" }, "Pending medical questionnaire", -1)
const _hoisted_5 = { class: "text-sm text-darkgray-800" }
const _hoisted_6 = { class: "flex flex-wrap space-y-1 border-b text-darkgray-900 pb-7 mb-7 border-gray-40 lg:space-y-0" }
const _hoisted_7 = { class: "w-full lg:w-1/2" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Date Booked")
], -1)
const _hoisted_10 = { class: "col-span-1 text-right" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Time Booked")
], -1)
const _hoisted_13 = { class: "col-span-1 text-right" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "w-full lg:w-1/2 lg:pl-12" }
const _hoisted_16 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Schedule Logs")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500" }, "Show", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Medical questionnaire")
], -1)
const _hoisted_21 = { class: "col-span-1 text-right" }
const _hoisted_22 = { class: "flex items-center space-x-3 mb-7" }
const _hoisted_23 = {
  key: 1,
  class: "flex flex-wrap"
}
const _hoisted_24 = { class: "w-full lg:w-1/2" }
const _hoisted_25 = { class: "lg:pb-7 mb-7 lg:border-b lg:border-gray-40" }
const _hoisted_26 = { class: "pl-5 list-disc" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, "N/A", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex items-center space-x-2.5 font-bold text-primary-500" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Download PDF", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("small", { class: "italic" }, "Download the preparation materials here", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "Doctor's Notes: ", -1)
const _hoisted_37 = { class: "text-darkgray-800" }
const _hoisted_38 = { class: "hidden mt-12 lg:flex" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "w-full lg:w-1/2 lg:pl-12" }
const _hoisted_41 = { class: "rounded-[10px] bg-white py-7 px-5 text-darkgray-900" }
const _hoisted_42 = { class: "grid grid-cols-12 gap-2.5 border-b border-gray-40 pb-4 mb-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
], -1)
const _hoisted_44 = { class: "col-span-8 text-right" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-on")
], -1)
const _hoisted_46 = { class: "col-span-8 text-right" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "accordion" }
const _hoisted_50 = { class: "font-bold text-primary-500 cursor-pointer text-sm" }
const _hoisted_51 = { class: "ml-1 text-xs" }
const _hoisted_52 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_53 = { class: "text-sm" }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", null, "N/A", -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
], -1)
const _hoisted_58 = { class: "col-span-8 text-right" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
], -1)
const _hoisted_60 = { class: "col-span-8 text-right" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
], -1)
const _hoisted_62 = { class: "col-span-8 text-right" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
], -1)
const _hoisted_64 = { class: "col-span-8 text-right" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Discount")
], -1)
const _hoisted_66 = { class: "col-span-8 text-right text-red-600" }
const _hoisted_67 = {
  key: 0,
  class: "grid grid-cols-12 gap-2.5 text-primary-500"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "Total")
], -1)
const _hoisted_69 = { class: "col-span-6 text-right" }
const _hoisted_70 = { class: "text-xl font-bold" }
const _hoisted_71 = { class: "flex mt-12 lg:hidden" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 2,
  class: "min-h-[calc(100vh-500px)]"
}
const _hoisted_74 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}
const _hoisted_75 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-6 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, " ADVISORY ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-6 text-2xl font-bold text-center text-black-500 lg:text-2xl" }, [
  /*#__PURE__*/_createTextVNode(" We would like to inform you that our Test Results Page is currently underway and will soon be available on our patient portal."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" With this feature, you can get convenient access to your test results and receive any health information you may need with ease."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Stay tuned for further updates, and thank you for your patience and understanding. ")
], -1)

import PortalLayout from '@/layouts/PortalLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import TestResultCard from '@/views/dashboard/test-results/TestResultCard.vue';

import { ChevronLeftIcon, ExclamationCircleIcon, ArrowDownTrayIcon } from "@heroicons/vue/24/outline";
import { useRouter, useRoute } from 'vue-router';

import { ref, onMounted, computed } from 'vue';

import patient from "@/classes/UserData";
import TestResults from "@/classes/TestResults";

import { format } from 'date-fns';
import { formatter } from '@/helpers/NumberHelper';
import { formatDate } from '@/helpers/TimeFormatter'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const appointment = ref()
const bookingId = ref(route.params.id as unknown as string);
const laboratoryId = ref(route.query.laboratory_id as unknown as string);
const testResult = ref({})
const testResultFile = ref(null);
const sampleBase64 = ref(null);
const bookedPackage = ref()
const isAccordionOpen = ref(false);

const tabSelected = ref('Information');

const packageFee = computed(() => appointment.value.package_fee);
const riderFee = computed(() => appointment.value.misc_fee);

const toggleAccordion = () => {
    isAccordionOpen.value = !isAccordionOpen.value;
};

const fetchSelectedAppointment = () => {
    loader.value = true
    
    patient.getSelectedAppointment(bookingId.value)
        .then((result: any) => {
            loader.value = false;
            appointment.value = result.data.response;
            if(appointment.value) {

                // laboratoryId.value = appointment.value.laboratory_results.length > 0 ? appointment.value.laboratory_results[0].laboratory_id : null;
                // if(laboratoryId.value) {
                //     getSelectedTestResults();
                // }
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
            }
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                router.push('/appointments/not-found');
            }
        })
}

const getSelectedTestResults = () => {
    loader.value = true
    
    patient.getSelectedTestResults(laboratoryId.value)
        .then((result: any) => {
            loader.value = false;
            testResult.value = result.data.response;

            // getSampleBase64Pdf();
            setTimeout(() => {
                convertBase64ToPdf();
            }, 100)
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const viewTestResult = (laboratory_id:string) => {
 
    loader.value = true

    TestResults.view(laboratory_id)
        .then(({data}) => {
            loader.value = false

            const decodedString = atob(data.response.lab_result_base_64);
            const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const testResultFile = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = testResultFile;
            link.target = '_blank';
            link.click();

        })
        .catch((err) => {
            loader.value = false
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })


}

const getSampleBase64Pdf = () => {

    const xhr = new XMLHttpRequest();
      xhr.open('GET', '/assets/file/sampleBase64.txt', true);
      xhr.onload = () => {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
            sampleBase64.value = xhr.responseText;
        }
      };
      xhr.send();

}

const convertBase64ToPdf = () => {
    // const decodedString = atob(testResult.value.lab_result_base_64 ? testResult.value.lab_result_base_64 : sampleBase64.value);

    if(testResult.value.lab_result_base_64) {
        const decodedString = atob(testResult.value.lab_result_base_64);
        const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        testResultFile.value = URL.createObjectURL(blob);
    }
}

const viewMedicalQuestionnaire = (booking_id: number) => {
    router.push('/medical-questionnaire/' + booking_id)
}

const viewScheduleLogs = (booking_type: string) => {
    if(booking_type == 'Individual') {
        window.location.assign(`/schedule-logs/${appointment.value.booking_id}?booking_type=${booking_type}`);
    } else {
        window.location.assign(`/schedule-logs/${appointment.value.corporate_booking_id}?booking_type=${booking_type}&booking_id_of_coporate_booking=${appointment.value.booking_id}`);
    }
}

const backToAppointment = () => {
    window.location.replace('appointment')
}

const downloadPdf = () => {
    if (appointment.value && appointment.value?.package_details[0]?.file_attachment) {
        const base64Data = appointment.value.package_details[0]?.file_attachment;

        // Check if it's a base64 string
        let fileAttachment = null;
        if (typeof base64Data === 'string' && base64Data.startsWith('data:')) {
            // Get the MIME type from the base64 string
            const mimeType = base64Data.split(';')[0].split(':')[1];
            // Convert base64 to blob
            const byteCharacters = atob(base64Data.split(',')[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            
            // Create File object from Blob
            fileAttachment = new File([blob], appointment.value.package_name, { type: mimeType });
        }
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileAttachment);
        link.download = `${appointment.value.package_name}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
    } else {
        console.error('PDF data not available');
    }
}

const testResultAdvisory = computed(() => {
    return 'VUE_APP_MODE' in process.env && process.env.VUE_APP_MODE == 'test_results';
})


const riders = computed(() => {
    return 'Selected Procedures Only';

    // if(!appointment.value?.other_charges_details) {
    //     return '';
    // }

    // if(typeof appointment.value?.other_charges_details == 'string') {
    //     return appointment.value?.other_charges_details;
    // }

    // if (appointment.value?.other_charges_details?.length <= 0) {
    //     return '';
    // }
    
    // const riderDescriptions = appointment.value?.other_charges_details
    //     .flatMap((other_charge: any) => 
    //         other_charge.trans_line.flatMap((rider: any) => 
    //             rider.items?.description ? rider.items.description : []
    //         )
    //     );
    
    // return riderDescriptions.join(', ');
})


onMounted(() => { 
    fetchSelectedAppointment()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, {
    title: appointment.value?.package_name || riders.value || 'Fetching Appointment',
    "hide-notification": true
  }, {
    fields: _withCtx(() => []),
    default: _withCtx(() => [
      (appointment.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!appointment.value.medical_questionnaire)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(ExclamationCircleIcon), { class: "flex-shrink-0 w-6 h-6 text-orange-600" }),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("p", _hoisted_5, "Please fill up your medical questionnaire before your appointment on " + _toDisplayString(_unref(formatDate)(appointment.value.booking_date)) + ".", 1)
                    ]),
                    _createElementVNode("p", {
                      class: "self-center font-bold cursor-pointer text-primary-500 whitespace-nowrap",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/medical-questionnaire/' + appointment.value.booking_id)))
                    }, "Fill Up Now")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(formatDate)(appointment.value.booking_date)), 1)
                  ]),
                  (appointment.value.booking_type == 'Individual')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(appointment.value.booking_start_time ?
                                        new Date(appointment.value.booking_start_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                        'TBA') + " - " + _toDisplayString(appointment.value.booking_end_time ?
                                        new Date(appointment.value.booking_end_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                        'TBA'), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (viewScheduleLogs(appointment.value.booking_type))),
                    class: "col-span-1 text-right cursor-pointer"
                  }, _hoisted_19),
                  (appointment.value.medical_questionnaire)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("p", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (viewMedicalQuestionnaire(appointment.value.booking_id))),
                            class: "font-bold cursor-pointer text-primary-500"
                          }, "View")
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Information' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (tabSelected.value = 'Information'))
              }, " Information ", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Test Results' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (tabSelected.value = 'Test Results'))
              }, " Test Results ", 2)
            ]),
            (tabSelected.value == 'Information')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("ul", _hoisted_26, [
                        (appointment.value?.package_details[0]?.trans_line?.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value.package_details[0]?.trans_line, (service) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: service.package_id
                                }, [
                                  _createElementVNode("li", null, _toDisplayString(service.item_description), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                      ]),
                      (appointment.value?.package_details[0]?.file_attachment)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _withModifiers(downloadPdf, ["prevent"]),
                            target: "_blank",
                            class: "block mt-4 w-fit"
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_unref(ArrowDownTrayIcon), { class: "w-5 h-5" }),
                              _hoisted_33
                            ]),
                            _hoisted_34
                          ], 8, _hoisted_31))
                        : _createCommentVNode("", true)
                    ]),
                    (appointment.value?.doctors_note)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("p", _hoisted_37, _toDisplayString(appointment.value?.doctors_note), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(backToAppointment, ["prevent"]),
                        class: "flex items-center font-bold cursor-pointer text-primary-500"
                      }, [
                        _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                        _createTextVNode(" Go back ")
                      ], 8, _hoisted_39)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("p", null, _toDisplayString(appointment.value.branch_name), 1)
                        ]),
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("p", null, _toDisplayString(appointment.value.package_name || 'N/A'), 1),
                          (typeof appointment.value?.other_charges_details == 'string')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(appointment.value?.other_charges_details), 1))
                            : (appointment.value?.other_charges_details.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("div", {
                                      class: "accordion-header",
                                      onClick: toggleAccordion
                                    }, [
                                      _createElementVNode("p", _hoisted_50, [
                                        _createTextVNode(" Selected Procedures Only "),
                                        _createElementVNode("span", _hoisted_51, _toDisplayString(isAccordionOpen.value ? '▲' : '▼'), 1)
                                      ])
                                    ]),
                                    (isAccordionOpen.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value?.other_charges_details, (other_charge) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: other_charge.transaction_code
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(other_charge.trans_line, (rider) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: rider.item_id
                                                }, [
                                                  _createElementVNode("p", _hoisted_53, _toDisplayString(rider.items?.description), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                        ]),
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("p", null, _toDisplayString(_unref(formatDate)(appointment.value.booking_date)), 1)
                        ]),
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, _toDisplayString(appointment.value.booking_start_time ?
                                    new Date(appointment.value.booking_start_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                    'TBA') + " - " + _toDisplayString(appointment.value.booking_end_time ?
                                    new Date(appointment.value.booking_end_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                    'TBA'), 1),
                        (appointment.value.patient_type != 'Corporate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_61,
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(packageFee.value)), 1)
                              ]),
                              _hoisted_63,
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(riderFee.value)), 1)
                              ]),
                              (appointment.value.discount_code && appointment.value.discount_amount > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_65,
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("p", null, "(" + _toDisplayString(appointment.value.discount_code) + ") - " + _toDisplayString(_unref(formatter).format(appointment.value.discount_amount)), 1)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (appointment.value.patient_type != 'Corporate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("p", _hoisted_70, _toDisplayString(_unref(formatter).format(appointment.value.total_fee)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(backToAppointment, ["prevent"]),
                      class: "flex items-center font-bold cursor-pointer text-primary-500"
                    }, [
                      _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                      _createTextVNode(" Go back ")
                    ], 8, _hoisted_72)
                  ])
                ]))
              : _createCommentVNode("", true),
            (tabSelected.value != 'Information')
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  (!testResultAdvisory.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (appointment.value?.laboratory_results.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value?.laboratory_results, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createVNode(TestResultCard, {
                                    badge: false,
                                    item: item,
                                    onClick: ($event: any) => (viewTestResult(item.laboratory_id))
                                  }, null, 8, ["item", "onClick"])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_75, " No results "))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_76,
                        _hoisted_77
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})